import { createSlice } from '@reduxjs/toolkit';
import _ from 'lodash';
import { getDomain, getMenuListURL } from '../../services/menuEndpoints';
import httpService from '../../services/httpService';
import { menuListAdapter } from '../../adapters/menuAdapters';
import IFrame from '../../components/inicio/IFrame';
import Home from '../../components/inicio/Home';
import { useSelector } from 'react-redux';

const DOMAIN = getDomain();

const INITIAL_STATE = {
  menuList: [],
  menuActivo: {},
  menusAbiertos: [],
  menusAbiertosComponents: [<Home />],
};

export const menuSlice = createSlice({
  name: 'menuSlice',
  initialState: INITIAL_STATE,
  reducers: {
    setMenuList: (state, action) => {
      state.menuList = action.payload;
    },
    actualizaMenusAbiertos: (state, action) => {
      state.menusAbiertos.push(action.payload);
    },
    agregaMenusAbiertosComponentes: (state, action) => {
      state.menusAbiertosComponents.push(action.payload);
    },
    actualizaMenusAbiertosComponentes: (state, action) => {
      state.menusAbiertosComponents = action.payload;
    },
    actualizaMenuCierre: (state, action) => {
      state.menusAbiertos = action.payload;
    },
    setMenuActivo: (state, action) => {
      state.menuActivo = action.payload;
    },
  },
});

//obtiene listado de menu
export const fetchMenuList = () => async (dispatch, getState) => {
  const {
    preferred_username: userName,
    resource_access,
    realm_access,
  } = getState().authReducer.userData;

  const { roles } = realm_access;

  /*
  const { roles } = resource_access.account;
  const url = `${DOMAIN}${getMenuListURL(roles[0], userName)}`;
  */
  const url = `${DOMAIN}${getMenuListURL(roles, userName)}`;
  httpService
    .get(url)
    .then(({ data }) => {
      //console.log("data: ", data);
      const menuLista = menuListAdapter(data);
      dispatch(setMenuList(menuLista));
      dispatch(agregaMenuActivo(menuLista[0]));
    })
    .catch((error) => {
      console.log('Error obteniendo listado de menu: ', error);
    });
};

export const agregaMenuActivo = (menu) => async (dispatch, getState) => {
  const copiaMenus = [...getState().menuReducer.menusAbiertos];
  const menuEncontrado = _.filter(copiaMenus, { idMenu: menu.idMenu });

  if (!Boolean(menuEncontrado.length)) {
    dispatch(actualizaMenusAbiertos(menu));
    if (menu.idMenu !== 0) {
      dispatch(agregaMenusAbiertosComponentes(<IFrame pagina={menu} />));
    }
    dispatch(setMenuActivo(menu));
  }
};

export const cierraMenuActivo = (menu) => async (dispatch, getState) => {
  const copiaMenus = [...getState().menuReducer.menusAbiertos];
  const copiaMenusAbiertosComponentes = [
    ...getState().menuReducer.menusAbiertosComponents,
  ];
  const menuEncontrado = _.filter(copiaMenus, { idMenu: menu.idMenu });

  //elimina menu de listado de componentes
  const indiceMenuActivo = _.findIndex(copiaMenus, { idMenu: menu.idMenu });
  const nuevoMenusAbiertosComponentes = copiaMenusAbiertosComponentes.filter(
    (_, index) => index !== indiceMenuActivo
  );

  //cierra pagina
  if (Boolean(menuEncontrado.length)) {
    const nuevaLista = _.filter(copiaMenus, (i) => i.idMenu !== menu.idMenu);
    dispatch(actualizaMenuCierre(nuevaLista));
    dispatch(actualizaMenusAbiertosComponentes(nuevoMenusAbiertosComponentes));
    //cambia página activa a la última si la página que se esta cerrado es la activa actualmente
    if (menu.idMenu === getState().menuReducer.menuActivo.idMenu) {
      dispatch(estableceMenuActivo(nuevaLista[nuevaLista.length - 1].idMenu));
    }
  }
};

export const estableceMenuActivo = (idMenu) => (dispatch, getState) => {
  const copiaMenusAbiertos = [...getState().menuReducer.menusAbiertos];
  const menu = _.filter(copiaMenusAbiertos, {
    idMenu: parseInt(idMenu),
  });

  dispatch(
    setMenuActivo(
      menu.length ? menu[0] : copiaMenusAbiertos[copiaMenusAbiertos.length - 1]
    )
  );
};

export const {
  setMenuList,
  actualizaMenusAbiertos,
  agregaMenusAbiertosComponentes,
  actualizaMenusAbiertosComponentes,
  actualizaMenuCierre,
  setMenuActivo,
} = menuSlice.actions;
export default menuSlice.reducer;
